import { Html } from "@custom/schema";
import clsx from "clsx";
import React from "react";
import IconSvg from "../molecules/IconSvg";
export default function TwoColInfo(props) {
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "px-6 md:px-14 mb-12 md:mb-16 lg:mb-24 relative overflow-hidden"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-7xl text-center overflow-hidden"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: clsx("font-heading font-medium text-2xl md:text-3xl mb-3 md:mb-0", {
            "mb-0.5 md:mb-4": props.subheading,
            "mb-9 md:mb-16": !props.subheading
        })
    }, props.heading), props.subheading ? /*#__PURE__*/ React.createElement("p", {
        className: "text-base lg:text-xl text-gray-200 mb-10 md:mb-14"
    }, props.subheading) : null, /*#__PURE__*/ React.createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "lg:max-w-5xl mx-auto text-left"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "md:flex md:gap-x-16 md:justify-center"
    }, props.info.map(function(item, index) {
        /*#__PURE__*/ return React.createElement("div", {
            key: index,
            className: "border-b-4 border-b-blue-500 pb-4 md:pb-7 relative md:flex-1 mb-9 md:m-0 prose"
        }, (item === null || item === void 0 ? void 0 : item.url) && /*#__PURE__*/ React.createElement(IconSvg, {
            keyword: item.icon || "",
            url: item.url,
            className: "w-6 md:w-9 md:h-9 mb-3 md:mb-5"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "text-xl block mb-3 font-heading font-semibold"
        }, item === null || item === void 0 ? void 0 : item.title), (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/ React.createElement(Html, {
            markup: item === null || item === void 0 ? void 0 : item.description
        }));
    })))))));
}
